// extracted by mini-css-extract-plugin
module.exports = {"blocksBox":"Blocks_blocksBox__2ysC6"};